import { Text } from '@chakra-ui/react'
import { Format, ScalarContentNode } from '@helo/cms'
import { merge } from 'lodash'

import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import {
  toLocalWallClockDateString,
  toWallClockDateString,
} from '../../utils/dates'

interface DateRendererProps {
  isLoading?: boolean
  contentNode: ScalarContentNode
}

export const DateRenderer = ({
  contentNode,
  isLoading,
  ...props
}: DateRendererProps) => {
  const { size, dateRelativeUnit, styles, _tooltip } = contentNode.state

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  const showSkeleton = !!isLoading

  if (dateRelativeUnit) {
    if (showSkeleton) {
      return (
        <Text size={size} {...props} {...customStyles}>
          <InlineSkeleton isLoading />
        </Text>
      )
    }

    const parts = Format.relativeDateParts(contentNode.state)(
      toLocalWallClockDateString(contentNode.data),
    )

    if (!parts) {
      return '-'
    }

    return (
      <div
        style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}
        {...props}
      >
        <Text size={size} {...customStyles}>
          {parts.count}
        </Text>
        <Text size={size}>{parts.suffix}</Text>
      </div>
    )
  }

  return (
    <ConditionalTooltip isDisabled={showSkeleton} tooltipOptions={_tooltip}>
      <Text size={size} {...props} {...customStyles}>
        <InlineSkeleton isLoading={showSkeleton}>
          {Format.date(contentNode.state)(
            toWallClockDateString(contentNode.data),
          )}
        </InlineSkeleton>
      </Text>
    </ConditionalTooltip>
  )
}
